interface RouteState {
    initialParams: string;
  }
  
  interface Action {
    type: string;
    payload: any;
  }
  
  const currentRouteReducer = (
    state: RouteState = { initialParams: "" },
    action: Action
  ): RouteState => {
    switch (action.type) {
      case "SET_CURRENT_ROUTE":
        return { ...state, initialParams: action.payload };
      default:
        return state;
    }
  };
  
  export default currentRouteReducer;
  